module.exports = __webpack_public_path__ + "img/pattern_login.9621b050.svg";